import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class CreateEntityMpProvider {
  public static async addPoint(
    data: typeof RegionShared.Client.Requests.PointAddRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.PointAddResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.PointAddRequest,
      typeof RegionShared.Client.Responses.PointAddResponse
    >(RegionShared.Client.Events.Point.PointAdd, data);
  }

  public static async removePoint(
    data: typeof RegionShared.Client.Requests.PointRemoveRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.PointRemoveResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.PointRemoveRequest,
      typeof RegionShared.Client.Responses.PointRemoveResponse
    >(RegionShared.Client.Events.Point.PointRemove, data);
  }

  public static async clearPoints(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.PointsClearResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      undefined,
      typeof RegionShared.Client.Responses.PointsClearResponse
    >(RegionShared.Client.Events.Point.PointsClear, undefined);
  }

  public static async createHouse(
    data: typeof RegionShared.Backend.Requests.HouseCreateRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.HouseCreateResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.HouseCreateRequest,
      typeof RegionShared.Backend.Responses.HouseCreateResponse
    >(RegionShared.Backend.Events.Estate.HouseCreate, data);
  }

  public static async createGasStation(
    data: typeof RegionShared.Backend.Requests.GasStationCreateRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GasStationCreateResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GasStationCreateRequest,
      typeof RegionShared.Backend.Responses.GasStationCreateResponse
    >(RegionShared.Backend.Events.GasStation.GasStationCreate, data);
  }

  public static async setInterior(
    data: typeof RegionShared.Backend.Requests.InteriorSetRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.InteriorSetResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.InteriorSetRequest,
      typeof RegionShared.Backend.Responses.InteriorSetResponse
    >("InteriorSet", data);
  }

  /**
   * Получить список улиц */
  public static async getAddressStreets(
    data: typeof RegionShared.Backend.Requests.GetAddressStreetsRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetAddressStreetsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetAddressStreetsRequest,
      typeof RegionShared.Backend.Responses.GetAddressStreetsResponse
    >(RegionShared.Backend.Events.Address.GetAddressStreets, data);
  }

  public static async getAddressStreet(
    data: typeof RegionShared.Backend.Requests.GetAddressStreetRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetAddressStreetResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetAddressStreetRequest,
      typeof RegionShared.Backend.Responses.GetAddressStreetResponse
    >(RegionShared.Backend.Events.Address.GetAddressStreet, data);
  }

  public static async getAddressPoints(
    data: typeof RegionShared.Backend.Requests.GetAddressPointsRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetAddressPointsResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetAddressPointsRequest,
      typeof RegionShared.Backend.Responses.GetAddressPointsResponse
    >(RegionShared.Backend.Events.Address.GetAddressPoints, data);
  }

  public static async getAddressPoint(
    data: typeof RegionShared.Backend.Requests.GetAddressPointRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetAddressPointResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetAddressPointRequest,
      typeof RegionShared.Backend.Responses.GetAddressPointResponse
    >(RegionShared.Backend.Events.Address.GetAddressPoint, data);
  }

  public static async addressStreetSet(
    data: typeof RegionShared.Backend.Requests.AddressStreetSetRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.AddressStreetSetResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.AddressStreetSetRequest,
      typeof RegionShared.Backend.Responses.AddressStreetSetResponse
    >(RegionShared.Backend.Events.Address.AddressStreetSet, data);
  }

  public static async addressPointSet(
    data: typeof RegionShared.Backend.Requests.AddressPointSetRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.AddressPointSetResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.AddressPointSetRequest,
      typeof RegionShared.Backend.Responses.AddressPointSetResponse
    >(RegionShared.Backend.Events.Address.AddressPointSet, data);
  }
}
